import { render } from "./ReferralDemographics.vue?vue&type=template&id=90a0e1f2&ts=true"
import script from "./ReferralDemographics.vue?vue&type=script&lang=ts"
export * from "./ReferralDemographics.vue?vue&type=script&lang=ts"

import "./ReferralDemographics.vue?vue&type=style&index=0&id=90a0e1f2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__